import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dynamic-tariff.reducer';

export const DynamicTariffDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dynamicTariffEntity = useAppSelector(state => state.dynamicTariff.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dynamicTariffDetailsHeading">
          <Translate contentKey="crawlerBackendApp.dynamicTariff.detail.title">DynamicTariff</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{dynamicTariffEntity.id}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="crawlerBackendApp.dynamicTariff.price">Price</Translate>
            </span>
          </dt>
          <dd>{dynamicTariffEntity.price}</dd>
          <dt>
            <span id="from">
              <Translate contentKey="crawlerBackendApp.dynamicTariff.from">From</Translate>
            </span>
          </dt>
          <dd>
            {dynamicTariffEntity.from ? (
              <TextFormat value={dynamicTariffEntity.from} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="until">
              <Translate contentKey="crawlerBackendApp.dynamicTariff.until">Until</Translate>
            </span>
          </dt>
          <dd>
            {dynamicTariffEntity.until ? (
              <TextFormat value={dynamicTariffEntity.until} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="productType">
              <Translate contentKey="crawlerBackendApp.dynamicTariff.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{dynamicTariffEntity.productType}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="crawlerBackendApp.dynamicTariff.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{dynamicTariffEntity.unit}</dd>
        </dl>
        <Button tag={Link} to="/dynamic-tariff" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dynamic-tariff/${dynamicTariffEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DynamicTariffDetail;
